import 'bootstrap/dist/css/bootstrap.min.css';
import ready from 'domready';
import React from 'react';
import ReactDOM from 'react-dom';
import Entry from './entry';
ready(() => {
    const container = document.createElement('main');
    ReactDOM.render(React.createElement(Entry, null), container, () => {
        document.body = document.createElement('body');
        document.body.appendChild(container);
    });
});
